const Kategoriya3111 = ()=>{
    return(
        <div style={{ fontFamily: "Times New Roman", fontSize: "14pt" }} className="container mt-5">
            <h3 className="text-center text-primary">
                3-sinf 1-chorak<br />
                Mavzu: Gap va uning turlari<br />
                "Eng oson" bo'limidagi topshiriqlar va ularni o'tkazish metodikasi
            </h3>
            <b>1-mashq. Nuqtalar o'rniga so'roqqa javob bo'ladigan qaysi so'zni qo'yish mumkin?</b><br />
            <i>Ta'limiy maqsad:</i> O'quvchilarning so'z tanlash mahoratini oshirish.<br />
            <i>Mashg'ulot davomiyligi:</i> 3-4 daqiqa<br />
            Shokolad … (nimadan?) olinadi. (sut, kakao, paxta, shakar)<br />
            Birinchi … (qanday?) avtomobil 1885-1886-yillari ikki nemis injenerlari Karl Bents va Gotlib Daymler tomonidan yaratildi. (katta, kichik, haqiqiy, chiroyli, qizil, sariq, oq)
            <p><b>2-mashq. Tushirib qoldirilgan harflarni tiklang va so'zlarni yozing.</b></p>
            <p><i>Ta'limiy maqsad:</i> O'quvchilarning imloviy malakalarini rivojlantirish.</p>
            <p><i>Mashg'ulot davomiyligi:</i> 1-2 daqiqa.</p>
            <p>Tenni…, j…xori, na…osat, …ushxulq.</p>
            <p><b>3-mashq. To'g'risini yozing.</b></p>
            <p><i>Ta'limiy maqsad:</i> O'quvchilarning imloviy hushyorlikka chorlash.</p>
            <p><i>Mashg'ulot davomiyligi:</i> 2-3 daqiqa.</p>
            <ul>
                <li>adabiy</li>
                <li>…okkey</li>
                <li>muqad…as</li>
                <li>ma…navi…at</li>
                <li>…ashar</li>
                <li>olo…on</li>
            </ul>
            <p><b>4-mashq. Nuqtalar o'rniga mos so'zni tanlab yozing?</b></p>
            <p><i>Ta'limiy maqsad:</i> O'quvchilarning lingvistik ko'nikmalarini rivojlantirish.</p>
            <p><i>Mashg'ulot davomiyligi:</i> 3-4 daqiqa.</p>
            <p>Jodugarning ummon uzra … (yurishi, yugurishi, sayohati) nihoyatda …. (mashaqqatli, xatarli, qo'rqinchli, quvonchli) va xatarli kechdi.</p>
            <p>… (birdaniga, kutilmaganda, to'satdan) Gingema qo'rqinchli, badburush bukri (cholga, yigitga, qizga, kampirga) aylandi va supurgisiga mindi.</p>
            <p><b>5-mashq. Maqolning davomini yozing.</b></p>
            <p><i>Ta'limiy maqsad:</i> O'quvchilarning sintaktik ko'nikmalarini rivojlantirish.</p>
            <p><i>Mashg'ulot davomiyligi:</i> 3-4 daqiqa.</p>
            <p>… aql, qanotsiz qush. Olim bo'lsang – … … .</p>
            <p>O'ynab gapirsang ham, … … .</p>
        </div>
    )
}
export default Kategoriya3111;